import React, { useState, useEffect } from 'react'
import {
    InputBase,
    Grid,
    Button
} from "@material-ui/core";
import useStyles from "./styles";
import Breadcrums from '../../components/BreadCrums/breadcrums';
import TopSpacer from '../../components/Common/spacer/TopSpacer';

import Loader from '../../components/Loader/Loader';
import { withSnackbar } from "../../components/Message/Alert";



function Chat({ trackingType, ...props }) {
    const classes = useStyles();


    //action dialog
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })




    const [state, setState] = useState({});

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {

    }, []);

    return (
        <>
            {isLoading ? <Loader></Loader> : ''}
            <TopSpacer></TopSpacer>

            <div className={classes.header}>

                <Grid container alignItems="baseline">
                    <Grid item lg={12}>
                        <Breadcrums parentLink={"Address Book"} isBack={true}></Breadcrums>
                    </Grid>
                </Grid>
            </div>

            <Grid container className={classes.container}>
                <h1 className={classes.heading}>
                    Chat
                </h1>
            </Grid>


            <Grid row className={classes.container} >
            <iframe src="https://livechat.figgersfoundation.org/index.php/site_admin/user/login"></iframe>

            </Grid>



        </>
    )

}

export default withSnackbar(Chat);